import React from 'react'
import {
  Table,
  Icon,
} from 'semantic-ui-react'
import {
  Link
} from 'react-router-dom'
import { areas } from './curriculum.js'
import Mastery from './Mastery.js'
import Tier from './Tier.js'
import OptionalSelectTableHeaderCell from './OptionalSelectTableHeaderCell.js'
import OptionalItemSelectorCell from './OptionalItemSelectorCell.js'
import OptionalItemCounterCell from './OptionalItemCounterCell.js'

class SelectedItemsTable extends React.Component {
  // props: mode, selection, itemKind, onToggle
  filterItems = () => {
    console.log("SelectedItemsTable::filterItems()");
    let rowInfos = [];
    if (this.props.selection) {
      for (const area of areas) {
        for (const unit of area.units) {
          if (this.props.itemKind==='outcomes'||this.props.itemKind==='both') {
            for (const outcome of unit.outcomes) {
              if (this.props.selection.items[outcome.fqid]) {
                rowInfos.push({
                  kind: 'outcome',
                  area: area,
                  unit: unit,
                  outcome: outcome,
                });
              }
            }
          }
          if (this.props.itemKind==='topics'||this.props.itemKind==='both') {
            for (const topic of unit.topics) {
              if (this.props.selection.items[topic.fqid]) {
                rowInfos.push({
                  kind: 'topic',
                  area: area,
                  unit: unit,
                  topic: topic,
                });
              }
              if (topic.topics) {
                for (const subtopic of topic.topics) {
                  if (this.props.selection.items[subtopic.fqid]) {
                    rowInfos.push({
                      kind: 'subtopic',
                      area: area,
                      unit: unit,
                      topic: topic,
                      subtopic: subtopic,
                    });
                  }
                  if (subtopic.topics) {
                    for (const subsubtopic of subtopic.topics) {
                      if (this.props.selection.items[subsubtopic.fqid]) {
                        rowInfos.push({
                          kind: 'subsubtopic',
                          area: area,
                          unit: unit,
                          topic: topic,
                          subtopic: subtopic,
                          subsubtopic: subsubtopic,
                        });
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    console.log("  rowInfos:", rowInfos);
    return rowInfos;
  }
  buildTable(rowInfos) {
    console.log("SelectedItemsTable::buildTable()");
    const rows = [];
    let area = null;
    let unit = null;
    let topic = null;
    let subtopic = null;
    for (const rowInfo of rowInfos) {
      if (rowInfo.area!==area) {
        area = rowInfo.area;
        rows.push(
          <Table.Row warning key={area.id}>
            <Table.Cell collapsing></Table.Cell>
            <Table.Cell collapsing>{area.id}</Table.Cell>
            <Table.Cell colSpan={3}><Link to={"/area/"+area.id}><b>
              {area.name}
            </b></Link></Table.Cell>
            <Table.Cell collapsing></Table.Cell>
            <Table.Cell collapsing></Table.Cell>
            <OptionalItemCounterCell mode={this.props.mode} selection={this.props.selection} fqidPrefix={area.id} itemKind={this.props.itemKind}/>
          </Table.Row>
        );
      }
      if (rowInfo.unit!==unit) {
        unit = rowInfo.unit;
        rows.push(
          <Table.Row key={unit.fqid}>
            <Table.Cell collapsing></Table.Cell>
            <Table.Cell collapsing disabled>{unit.fqid}</Table.Cell>
            <Table.Cell colSpan={3}><Link to={"/unit/"+unit.fqid}>
              {unit.name}
            </Link></Table.Cell>
            <Table.Cell collapsing></Table.Cell>
            <Table.Cell collapsing></Table.Cell>
            <OptionalItemCounterCell mode={this.props.mode} selection={this.props.selection} fqidPrefix={unit.fqid} itemKind={this.props.itemKind}/>
          </Table.Row>
        );
      }
      if (rowInfo.outcome) {
        let outcome = rowInfo.outcome;
        rows.push(
          <Table.Row key={outcome.fqid}>
            <Table.Cell collapsing><Icon name='trophy'/></Table.Cell>
            <Table.Cell collapsing disabled>{outcome.id}</Table.Cell>
            <Table.Cell colSpan={3}>
              {outcome.name}
            </Table.Cell>
            <Table.Cell collapsing textAlign='center'><Mastery mastery={outcome.mastery}/></Table.Cell>
            <Table.Cell collapsing textAlign='center'><Tier tier={outcome.tier}/></Table.Cell>
            <OptionalItemSelectorCell mode={this.props.mode} selection={this.props.selection} onToggle={this.props.onToggle} fqid={outcome.fqid}/>
          </Table.Row>
        );
      }
      if (rowInfo.topic) {
        if (rowInfo.topic!==topic || rowInfo.kind==='topic') {
          topic = rowInfo.topic;
          const disabled = rowInfo.kind!=='topic';
          rows.push(
            <Table.Row key={topic.fqid}>
              <Table.Cell collapsing><Icon name='map marker'/></Table.Cell>
              <Table.Cell collapsing disabled>{topic.id}</Table.Cell>
              <Table.Cell colSpan={3} disabled={disabled}>{topic.name}</Table.Cell>
              <Table.Cell collapsing></Table.Cell>
              <Table.Cell collapsing textAlign='center'><Tier tier={topic.tier}/></Table.Cell>
              <OptionalItemSelectorCell mode={this.props.mode} selection={this.props.selection} onToggle={this.props.onToggle} fqid={topic.fqid}/>
            </Table.Row>
          );
        }
      }
      if (rowInfo.subtopic) {
        if (rowInfo.subtopic!==subtopic || rowInfo.kind==='subtopic') {
          subtopic = rowInfo.subtopic;
          const disabled = rowInfo.kind!=='subtopic';
          rows.push(
            <Table.Row key={subtopic.fqid}>
              <Table.Cell collapsing><Icon name='map marker'/></Table.Cell>
              <Table.Cell collapsing disabled>{topic.id}.{subtopic.id}</Table.Cell>
              <Table.Cell collapsing>&bull;</Table.Cell>
              <Table.Cell colSpan={2} disabled={disabled}>{subtopic.name}</Table.Cell>
              <Table.Cell collapsing></Table.Cell>
              <Table.Cell collapsing textAlign='center'><Tier tier={subtopic.tier}/></Table.Cell>
              <OptionalItemSelectorCell mode={this.props.mode} selection={this.props.selection} onToggle={this.props.onToggle} fqid={subtopic.fqid}/>
            </Table.Row>
          );
        }
      }
      if (rowInfo.subsubtopic) {
        const subsubtopic = rowInfo.subsubtopic;
        rows.push(
          <Table.Row key={subtopic.fqid}>
            <Table.Cell collapsing><Icon name='map marker'/></Table.Cell>
            <Table.Cell collapsing disabled>{topic.id}.{subtopic.id}.{subsubtopic.id}</Table.Cell>
            <Table.Cell collapsing></Table.Cell>
            <Table.Cell collapsing>-</Table.Cell>
            <Table.Cell>{subsubtopic.name}</Table.Cell>
            <Table.Cell collapsing></Table.Cell>
            <Table.Cell collapsing textAlign='center'><Tier tier={subsubtopic.tier}/></Table.Cell>
            <OptionalItemSelectorCell mode={this.props.mode} selection={this.props.selection} onToggle={this.props.onToggle} fqid={subsubtopic.fqid}/>
          </Table.Row>
        );
      }
    }
    console.log(rows);
    return rows;
  }
  render() {
    console.log("SelectedItemsTable::render()");
    const rowInfos = this.filterItems();
    const rows = this.buildTable(rowInfos);
    return (
      <Table compact='very' basic='very'>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell collapsing/>
            <Table.HeaderCell collapsing/>
            <Table.HeaderCell colSpan={3}>Name</Table.HeaderCell>
            <Table.HeaderCell collapsing textAlign='center'>Mastery</Table.HeaderCell>
            <Table.HeaderCell collapsing textAlign='center'>Tier</Table.HeaderCell>
            <OptionalSelectTableHeaderCell mode={this.props.mode} selection={this.props.selection}/>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          { rows }
        </Table.Body>
      </Table>
    );
  }
}

export default SelectedItemsTable